import React, {useState} from 'react';
import {Checkbox, Collapse} from 'antd';
import classes from './ScheduleFiltersMobile.module.scss';
import WeekFilters from "../WeekFilters/WeekFilters";
import SubgroupFilters from "../SubgroupFilters/SubgroupFilters";

const { Panel } = Collapse;

const ScheduleFiltersMobile = ({ lessonType, isCurrentPeriod, subgroupFilters, passedLessonsFilter,
                                   sessionFilter, setFilter, defaultWeek, showSubgroupFilters, scheduleType }) => {

    const [activePanels, setActivePanels] = useState([]);

    const setPassedLessonsFilterCheckbox = () => {
        return <Checkbox
            checked={passedLessonsFilter}
            onChange={(e) => setFilter(e.target.checked, "passedLessonsFilter")}>
            Показать прошедшие занятия
        </Checkbox>;
    }

    const setSessionFilterCheckbox = () => {
        return <Checkbox
            checked={sessionFilter}
            onChange={(e) => setFilter(e.target.checked, "sessionFilter")}>
            Показать сессию
        </Checkbox>;
    }

    const getPanelTitle = () => {
        return activePanels.length === 0 ? "Показать" : "Скрыть";
    }

    const getAdditionalFilters = () => {
        const getFiltersElement = () => (<React.Fragment>
            <div className={(lessonType === 'exams' || !isCurrentPeriod) ? classes.removed : null}>
                {setPassedLessonsFilterCheckbox()}
            </div>
            <div className={lessonType === 'exams' ? classes.removed : null}>
                {setSessionFilterCheckbox()}
            </div>
        </React.Fragment>);

        if (lessonType === 'exams' || (lessonType === 'exams' && !isCurrentPeriod)) {
            return null;
        }
        return (<Collapse className={classes.additionalFiltersMobile}
                          ghost
                          activeKey={activePanels}
                          onChange={setActivePanels}>

            <Panel header={getPanelTitle()} key="additionalFilters">
                <div style={{display: 'flex', flexDirection: 'column', rowGap: '12px'}}>
                    {getFiltersElement()}
                </div>
            </Panel>
        </Collapse>);
    }

    return (<div className={classes.container}>
        {lessonType !== 'exams' &&
        <div>
            <div className={classes.filterLabel}>Недели</div>
            <div style={{display: 'flex', flexWrap: 'wrap', rowGap: '8px'}}>
                <WeekFilters defaultWeek={defaultWeek}/>
            </div>
        </div>}
        {(showSubgroupFilters && scheduleType !== 2 && lessonType !== 'exams') &&
        <div>
            <div className={classes.filterLabel}>Подгруппы</div>
            <div>
                <SubgroupFilters setFilter={setFilter}
                                 subgroupFilters={subgroupFilters}/>
            </div>
        </div>}
        {getAdditionalFilters()}
    </div>);
}

export default ScheduleFiltersMobile;
